import {
    OUTWARD_GET_CATEGORY_FAILURE,
    OUTWARD_GET_CATEGORY_REQUEST,
    OUTWARD_GET_CATEGORY_SUCCESS,
} from "../actions/actionTypes";

const initialState = {
    outWardCategory: [],
    loading: false,
    error: null,
};

const outWardCategoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case OUTWARD_GET_CATEGORY_REQUEST:
            return { ...state, loading: true, error: null };
        case OUTWARD_GET_CATEGORY_SUCCESS:
            return { ...state, loading: false, outWardCategory: action.payload };
        case OUTWARD_GET_CATEGORY_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default outWardCategoryReducer;
